// This allows you to press the arrow keys up and down to focus differnt table rows and to respond to enter clicked
export default {
  data () {
    return {
      currentSelectedID: null,
      currentIndex: 0
    }
  },
  methods: {
    focusNextTableRow () {
      if (this.currentIndex < this.items.length - 1) {
        this.currentIndex ++
      }
    },
    focusPreviousTableRow () {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    onEnterKeyTableRow () {
      var match = this.items[this.currentIndex]
      if (match) {
        this.clickRow(match)
      }
    },
  }
}